module.exports = __webpack_public_path__ + "ee9362930621c6b06edc99c8705f35d4.svg";